<ngx-spinner bdColor="rgba(51,51,51,0.8)" size="medium" color="#fff" type="ball-scale-multiple">
  <p style="font-size: 20px; color: white">Processando...</p>
</ngx-spinner>
<div class="d-flex justify-content-center">
  <div class="d-flex flex-column align-items-center w-30 content-border m-5" style="zoom: 0.9">
    <div class="content-border-bottom w-100">
      <div class="d-flex flex-column gap-1 p-3">
        <span class="fs-16 fw-600">Obrigações Acessórias</span>
        <span class="fs-14 fw-400">Acesso restrito</span>
      </div>
    </div>
    <h1 class="fw-600 my-5" style="zoom: 0.8" tabindex="0">Acesso ao sistema</h1>
    <form (ngSubmit)="login()"
          class="d-flex flex-column align-items-center w-70content-border m-3">
      <mat-form-field style="width: 600px" fxFlex="100%" appearance="outline">
        <mat-label>
          <div class="d-flex justify-items-center gap-2">
            <mat-icon>person</mat-icon>
            <span>Usuário</span>
          </div>
        </mat-label>
        <input id="usuario" type="text" aria-label="Usuário" matInput [(ngModel)]="credentials.login" name="login" [disabled]="loginInProgress" required autocomplete="username"/>
      </mat-form-field>
      <mat-form-field style="width: 600px" fxFlex="100%" appearance="outline">
        <mat-label>
          <div class="d-flex justify-items-center gap-2">
            <mat-icon>lock</mat-icon>
            <span>Senha</span>
          </div>
        </mat-label>
        <input id="senha" type="password" aria-label="Senha" matInput [(ngModel)]="credentials.senha" name="senha" [disabled]="loginInProgress" required autocomplete="current-password"/>
      </mat-form-field>

      <div class="d-flex gap-3 flex-column align-items-center">
        <button
          id="botao-logar"
          mat-flat-button
          color="primary"
          style="width: 600px"
          class="mb-3"
          [disabled]="loginInProgress || !(credentials.senha.length > 0 && credentials.login.length > 0)"
          (keydown.enter)="login()"
          (click)="login()"
        >
          {{ loginInProgress ? 'Aguarde...' : 'Entrar' }}
        </button>
      </div>
    </form>
  </div>
</div>
